import React from "react";
import {Panel} from "rsuite";
// import "./CollapsiblePanel.css";

const CollapsiblePanel = ({className, props}) => {
    return (
        <Panel collapsible header={props.title} {...props} bordered>
            {/* {props.title && <header className="sc-panel__header">{}</header> || null} */}
            {/* <section>
                {props.children}
            </section> */}
        </Panel>
    )
}

export default CollapsiblePanel;
